import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Card, CardBody, Button } from "reactstrap";
import { Popover } from "antd";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import Axios from "axios";
import Swal from "sweetalert2";

import Loader from "../../Global/Loader";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import IMG_ADD from "../../../resources/icono_agregar.png";
import createModal from "../Components/ModalV2";
import { Services } from "../../../repositories/clients/Services";
import Table from "./../Components/Table";

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalDelete: false,
      dataItem: undefined,
      modalSuccess: false,
      searchOnInit: false,
      activePage: 1,
      data: [],
      searchText: "",
      loadingInfo: true,
      AddUser: (
        <div className="float-right">
          <Button
            color="primary"
            className="d-flex align-items-center"
            title={this.props.t("create_new")}
            onClick={() => {
              this.addUser();
            }}
          >
            <span className="icon-plus icon-button-add" />
            {this.props.t("create_new")}
          </Button>
        </div>
      ),
      columns: [
        {
          label: "ID",
          key: "UserId",
          minWidth: 60,
          maxWidth: 60,
          custom: (value) => (
            <span
              className="link-euro"
              onClick={() => {
                this.editRow(value);
              }}
            >
              {value.UserId}
            </span>
          ),
        },
        { label: this.props.t("first_name"), key: "Name", minWidth: 130 },
        { label: this.props.t("last_name"), key: "LastName", minWidth: 130 },
        { label: this.props.t("job_role"), key: "Role", minWidth: 150 },
        { label: this.props.t("job_position"), key: "Position", minWidth: 150 },
        {
          label: this.props.t("email"),
          key: "Email",
          minWidth: 300,
          maxWidth: 300,
        },
        { label: this.props.t("phone"), key: "Telephone", minWidth: 150 },
        { label: this.props.t("created_by"), key: "UserCreate", minWidth: 150 },
        {
          label: this.props.t("create_date"),
          key: "CreateDate",
          minWidth: 150,
        },
        { label: this.props.t("status"), key: "Pending", minWidth: 150 },
        {
          label: this.props.t("associated_companies"),
          key: "AssociatedEntities",
          minWidth: 150,
        },
        {
          label: "",
          key: "",
          minWidth: 50,
          maxWidth: 50,
          custom: (value) => {
            return (
              <span
                className="icon-delete icons-front-module"
                onClick={() => this.toggle(value)}
              />
            );
          },
        },
      ],
    };
  }

  componentDidMount = () => {
    this.getUserList();
  };
  sendMessage = (text, type) => {
    Swal.fire({
      icon: type,
      confirmButtonColor: "#0561fc",
      confirmButtonText: "Ok",
      html: `<div class="text-center euro-title-form">
      ${text}
      </div>`,
      customClass: {
        confirmButton: "custom-width-btn swal",
      },
    });
  };

  deleteUser = (value) => {
    let id = value.UserId;
    let userId = this.props._user;
    let token = this.props.token;

    Axios.delete(`${Services.ADMIN.path}admin/deleteUser/${id}/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        this.getUserList();
        this.setState({ modalDelete: false, modalSuccess: true });
      })
      .catch((error) => {
        if (error.response) {
          var mensaje = "";
          if (error.response.data.data) {
            mensaje = error.response.data.data.message;
          } else {
            mensaje = error.response.data.message;
          }
          this.sendMessage(mensaje, "error");
        }
      });
  };

  getUserList = async () => {
    let { data } = this.state;
    let userId = this.props._user;
    let token = this.props.token;

    await Axios.get(`${Services.ADMIN.path}admin/users/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        data = response.data.data;
        data.map((d) => {
          d.FullName = d.Name + " " + d.LastName;
          d.showPop = false;
          d.Pending =
            d.Pending == "0" ? this.props.t("active") : this.props.t("pending");
          return d;
        });
      })
      .catch((error) => {});
    this.setState({ data, loadingInfo: false, activePage: 1 });
  };

  updateActivePage = (activePage) => {
    this.setState({ activePage });
  };

  addUser = () => {
    this.props.history.push("/add-user");
  };

  handleCancel = (value) => {
    let { data } = this.state;
    data.map((d) => {
      if (value.UserId === d.UserId) {
        d.showPop = false;
      }
    });
    this.setState({
      data,
    });
  };
  handlePopChange = (value) => (visible) => {
    let { data } = this.state;
    data.map((d) => {
      if (value.UserId === d.UserId) {
        d.showPop = visible;
      }
    });
    this.setState({
      data,
    });
  };

  editRow = (data) => {
    this.props.history.push(`/user-detail/${data.UserId}`);
  };

  toggle = (item) =>
    this.setState({
      modalDelete: !this.state.modalDelete,
      dataItem: item,
    });

  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    let {
      columns,
      data,
      searchOnInit,
      searchText,
      loadingInfo,
      modalDelete,
      dataItem,
      modalSuccess,
    } = this.state;
    return loadingInfo ? (
      <Loader />
    ) : (
      <ContentWrapper>
        <div className="content-heading">
          <span className="icon-organizations icon-header colorPrimariLable" />
          {this.props.t("admin_module")}
        </div>
        <Card className="myCard">
          <CardBody>
            <Table
              columns={columns}
              data={data}
              itemsByPage={10}
              name="UserList"
              modalName="ui Modal body order list"
              customer={this.props._customer}
              user={this.props._user}
              customAdd={this.state.AddUser}
              updateActivePage={this.updateActivePage}
              activePage={this.state.activePage}
              rowClick={false}
              customClick={this.editRow}
              options={{
                pagination: true,
                search: true,
                panel: false,
                downloads: {
                  xlsx: true,
                  pdf: false,
                },
                selectItems: false,
                orderAttention: {
                  activeFilter: searchOnInit,
                  activeText: searchText,
                  search: true,
                  xlsx: false,
                },
                trigger: this.selectedOrder,
                searchKeys: [
                  "UserId",
                  "Name",
                  "LastName",
                  "Role",
                  "Position",
                  "Email",
                  "Telephone",
                  "CreateDate",
                  "AssociatedEntities",
                  "FullName",
                ],
              }}
              nameXlsx={this.props.t("admin_users_fname_xls_dowload_user")}
              cellType={"thick-rows"}
            />
          </CardBody>
        </Card>
        {createModal({
          isModalOpen: modalDelete,
          titleModal: this.props.t("po_visibility_comments_delete_alert"),
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{this.props.t("sure_delete_user")}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: this.props.t("po_management_detail_button_no"),
              onClick: this.toggle,
              type: "secondary",
            },
            {
              text: this.props.t("po_management_detail_button_yes"),
              onClick: () => this.deleteUser(dataItem),
              type: "primary",
            },
          ],
          onCancel: this.toggle,
        })}
        {createModal({
          isModalOpen: modalSuccess,
          titleModal: this.props.t("po_visibility_comments_delete_alert"),
          type: "success",
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{this.props.t("user_deleted")}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: this.props.t("Ok"),
              onClick: () => this.setState({ modalSuccess: false }),
              type: "primary",
            },
          ],
          onCancel: () => this.setState({ modalSuccess: false }),
        })}
      </ContentWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(withRouter(Admin)));
